import { useState, useEffect } from 'react'
import { useLocation } from '../useLocation'

const NOT_IN_MARKET = 'not in market'

type LocationChecker = {
  _type: 'locationchecker'
  options: Array<{
    location: string
    module: unknown
  }>
}

const useLocationChecker = (checker: LocationChecker): any => {
  const { country, state, location } = useLocation()
  const [modules, setModules] = useState<any>(null)

  useEffect(() => {
    const options = (checker.options || [])
      .filter(({ location }) => !!location)
      ?.map(({ location, module }) => ({
        location: location.toLowerCase(),
        module,
      }))

    // Make sure there's always a non-market option
    options.push({ location: NOT_IN_MARKET, module: null })

    /**
     * Check for first non-market location
     *
     * (can be the one specified in the checker or the safity one added above)
     */
    const nonMarket = options.find(
      option => option.location === NOT_IN_MARKET
    ) as { location: string; module: any }

    /**
     * If the country is not US, return the non-market option
     */
    if (country !== 'US') {
      setModules(nonMarket.module)
    } else {
      let matched = options.find(option => option.location === location)

      // If not found, check for state
      if (!matched) {
        matched = options.find(option => option.location === state)
      }

      setModules(matched ? matched.module : nonMarket.module)
    }
  }, [checker.options, location, country, state])

  return modules
}

export default useLocationChecker
export { useLocationChecker, LocationChecker } // Exporting useLocationChecker for named import
